module.exports = __webpack_public_path__ + "img/right_dots_pattern.a7c92615.svg";